import { colors, Spinner } from '@zipdrug/ui';
import React from 'react';
import Page from './Page';

export default () => (
  <Page style={{ color: colors.theme.primary.default }}>
    <Spinner loading />
  </Page>
);
